import { Flex, useToast } from "@chakra-ui/react";
import Button, { ButtonType } from "components/Button";
import Input from "components/Input";
import { ChangeEvent, useRef, useState } from "react";
import { useSupport } from "./useSupport";
import { AutoResizeTextarea } from "components/AutoResizeTextArea";

export default function SupportForm(): JSX.Element {
  const toast = useToast();
  const [error, setError] = useState<string | null>(null);
  const [subject, setSubject] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const textRef = useRef<HTMLTextAreaElement>(null);

  const { submitTicket, isPending } = useSupport();
  const handleSubject = (event: ChangeEvent<HTMLInputElement>) => {
    setSubject(event.target.value);
  };

  const handleChangeMessage = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const value = event.target.value;
    setMessage(value);
  };

  const handleSubmitTicket = async () => {
    error && setError(null);
    console.warn("add api subject, message: ", subject, message);
    const success = await submitTicket({
      feedback: message,
      subject,
    });
    if (!success) {
      toast({
        description: "Error Submitting Ticket",
        duration: 3000,
        isClosable: true,
        status: "error",
        title: "Error",
      });
      setError("Error submitting ticket");
      return;
    }
    setSubject("");
    setMessage("");
    toast({
      description: "A team member will review and get back to you shortly.",
      duration: 3000,
      isClosable: true,
      status: "success",
      title: "Successfully Sumbitted.",
    });
  };

  return (
    <Flex
      maxW="800px"
      alignItems="center"
      width="100%"
      flexDirection="column"
      marginTop="56px"
      paddingBottom="56px"
    >
      <Input
        marginBottom="16px"
        type="text"
        value={subject}
        placeholder="Subject"
        onChange={handleSubject}
      />
      <AutoResizeTextarea
        ref={textRef}
        value={message}
        // @ts-ignore
        onChange={handleChangeMessage}
        placeholder="Message"
        height="96px"
        minH="96px"
        marginTop="16px"
      />
      <Button
        width="164px"
        minH="64px"
        marginTop="56px"
        isDisabled={!subject || !message}
        onClick={handleSubmitTicket}
        isLoading={isPending}
        styleType={ButtonType.PRIMARY}
      >
        Submit
      </Button>
    </Flex>
  );
}
